import {GET_PEGAWAI} from 'shared/constants/ActionTypes';
import ItemCollections, {useGetItem} from 'redux/cache';
import {API} from 'shared/constants/AppEnums'; 
const itemCollections = new ItemCollections();
export const getEmployees = (searchText,useCRSFE,isTransform = false) => {
  let keyUrl = useCRSFE ? API.GET_EMPLOYEE_PENOMORAN_ADMINTOOLS : API.EMPLOYEES;
  let save = searchText ? false : true;
  let searchParam = useCRSFE ? '?is_detail=1&query=' : '?is_detail=1&search=';
  searchText ? (keyUrl += searchParam + searchText) : keyUrl+='?is_detail=1';
  isTransform? keyUrl+="&is_transformation=1" : ''
  return useGetItem(itemCollections, keyUrl, GET_PEGAWAI,false,save,false,useCRSFE);
};
